import * as React from 'react'

const SvgScheduleIcon = (props) => (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_12474_8547)">
    <rect x="2" y="1" width="48" height="48" rx="10" fill="#FF692E"/>
    <path d="M35 23H17M30 15V19M22 15V19M21.8 35H30.2C31.8802 35 32.7202 35 33.362 34.673C33.9265 34.3854 34.3854 33.9265 34.673 33.362C35 32.7202 35 31.8802 35 30.2V21.8C35 20.1198 35 19.2798 34.673 18.638C34.3854 18.0735 33.9265 17.6146 33.362 17.327C32.7202 17 31.8802 17 30.2 17H21.8C20.1198 17 19.2798 17 18.638 17.327C18.0735 17.6146 17.6146 18.0735 17.327 18.638C17 19.2798 17 20.1198 17 21.8V30.2C17 31.8802 17 32.7202 17.327 33.362C17.6146 33.9265 18.0735 34.3854 18.638 34.673C19.2798 35 20.1198 35 21.8 35Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="2.5" y="1.5" width="47" height="47" rx="9.5" stroke="#FF692E"/>
    </g>
    <defs>
    <filter id="filter0_d_12474_8547" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="1"/>
    <feGaussianBlur stdDeviation="1"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12474_8547"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12474_8547" result="shape"/>
    </filter>
    </defs>
    </svg>
)

export default SvgScheduleIcon
